module.exports = __webpack_public_path__ + "static/img/ba.9d92425.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ba.png
// module id = faa4
// module chunks = 1